/* globals siteurl */
import Cropper from 'cropperjs';
import './canvasToBlob';

let cropper = null;
let useBlackAndWhite = false;

const restoreOriginalCustomizePrint = (photoId) => {
  const formData = new FormData();
  formData.append('photoId', photoId);

  $.ajax(`${siteurl}/ajax/restore_original_print`, {
    method: 'POST',
    data: formData,
    processData: false,
    contentType: false,
    dataType: 'json',
    success(data) {
      if (data.status) {
        window.location.reload();
      }
    },
    error() {
    },
  });
};

const hideCropper = () => {
  $('#custom-print-controls').hide();
  $('#custom-print-preview').hide();
  $('.big-preview-wrapper').show();
  $('.hide-on-custom-mode').show();
};

const changeAspectRatioCustomizePrint = (value1, value2) => {
  const ratio = value1 / value2;
  cropper.setAspectRatio(ratio);
  return ratio;
};

const saveCustomizePrint = (photoId) => {
  const savedImageOptions = {
    imageSmoothingQuality: 'high',
  };

  cropper.getCroppedCanvas(savedImageOptions).toBlob((blob) => {
    const containerData = cropper.getContainerData();
    const imgData = cropper.getImageData();
    const cropData = cropper.getCropBoxData();
    const canvasData = cropper.getCanvasData();
    const startX_percentage = ((cropData.left - canvasData.left) * 100) / (imgData.width);
    const startY_percentage = ((cropData.top - canvasData.top) * 100) / (imgData.height);
    const width_percentage = ((cropData.width) * 100) / (imgData.width);
    const height_percentage = ((cropData.height) * 100) / (imgData.height);
    const width_pixels = cropData.width;
    const height_pixels = cropData.height;
    const rotationAngle = imgData.rotate;

    const formData = new FormData();

    formData.append('photoId', photoId);
    // Pass the image file name as the third parameter if necessary.
    formData.append('croppedImage', blob, 'croppedImage.jpg');
    formData.append('startX_pixels', cropData.left);
    formData.append('startY_pixels', cropData.top);
    formData.append('startX_percentage', startX_percentage);
    formData.append('startY_percentage', startY_percentage);
    formData.append('width_percentage', width_percentage);
    formData.append('height_percentage', height_percentage);
    formData.append('width_pixels', width_pixels);
    formData.append('height_pixels', height_pixels);
    formData.append('rotationAngle', rotationAngle);
    formData.append('use_black_and_white', useBlackAndWhite);

    $('.cp-confirm').append(' <i class="fa fa-spinner fa-spin"></i>').off();

    $.ajax(`${siteurl}/ajax/upload_custom_print`, {
      method: 'POST',
      data: formData,
      processData: false,
      contentType: false,
      dataType: 'json',
      success(data) {
        if (data.upload_status) {
          window.location.reload();
        }
      },
      error() {
        console.log('Upload error');
      },
    });

  }, 'image/jpeg');
};
const highlightRatioButton = (width, height) => {
  const division = width / height;
  let s = division.toFixed(2);
  s = s.replace('.', 'p');
  $('.cp-set-aspect-ratio').removeClass('selected');
  $(`.cp-ratio-${s}`).addClass('selected');
};

const showButtonsOfAxis = (axis) => {
  // handle format buttons containers
  $('.cp-buttons-horizontal').hide();
  $('.cp-buttons-vertical').hide();
  $(`.cp-buttons-${axis}`).show();

  // handle classes of selected buttons
  $('#cp-set-squared').removeClass('selected');
  $('#cp-set-horizontal').removeClass('selected');
  $('#cp-set-vertical').removeClass('selected');
  $(`#cp-set-${axis}`).addClass('selected');
  if (axis === 'squared') {
    changeAspectRatioCustomizePrint(1, 1);
  } else if (axis === 'horizontal') {
    $('.cp-ratio-1p33').click();
  } else if (axis === 'vertical') {
    $('.cp-ratio-0p75').click();
  }
};

const rotateCustomizePrint = (degree) => {
  cropper.rotate(degree);
};

const setBlackAndWhiteFilter = (value) => {
  useBlackAndWhite = value;
  if (value === true) {
    $('#cp-toggle-black-and-white').addClass('selected');
    $('.cropper-view-box img, .cropper-hide').addClass('cropper-black-and-white');
  } else {
    $('#cp-toggle-black-and-white').removeClass('selected');
    $('.cropper-view-box img, .cropper-hide').removeClass('cropper-black-and-white');
  }
};

const toggleBlackAndWhiteFilter = () => {
  if ($('.cropper-hide').hasClass('cropper-black-and-white')) {
    setBlackAndWhiteFilter(false);
  } else {
    setBlackAndWhiteFilter(true);
  }


};


const setDefaultData = () => {
  if ($('#cp-default-data').length > 0) {
    const defaultDataElement = $('#cp-default-data');

    rotateCustomizePrint(defaultDataElement.data('rotation-angle'));

    const ratio = changeAspectRatioCustomizePrint(defaultDataElement.data('width'), defaultDataElement.data('height'));

    // show the right aspect ratios depending on the default format
    if (defaultDataElement.data('width') > defaultDataElement.data('height')) {
      showButtonsOfAxis('horizontal');
    } else if (defaultDataElement.data('width') < defaultDataElement.data('height')) {
      showButtonsOfAxis('vertical');
    } else {
      showButtonsOfAxis('squared');
    }

    // highlight the default option
    highlightRatioButton(defaultDataElement.data('width'), defaultDataElement.data('height'));

    setBlackAndWhiteFilter(defaultDataElement.data('use-black-and-white'));

    cropper.setAspectRatio(ratio);

    cropper.setCropBoxData({
      left: defaultDataElement.data('x'),
      top: defaultDataElement.data('y'),
      width: defaultDataElement.data('width'),
      height: defaultDataElement.data('height'),
    });
  } else {
    showButtonsOfAxis('squared');
    highlightRatioButton(1, 1);
    cropper.setAspectRatio(1);
  }
};

const initializeCropper = () => {
  console.log("iitializing");
  const image = document.getElementById('custom-print-img');
  const options = {
    aspectRatio: 1 / 1,
    movable: false,
    zoomable: false,
    scalable: false,
    rotatable: false,
    responsive: true,
    minContainerHeight: 480,
    //minCanvasHeight: 300,
    viewMode: 1,
  };
  cropper = new Cropper(image, options);

  setTimeout(() => {
    setDefaultData();
  }, 300);
};

const showCropper = () => {
  $('#custom-print-controls').show();
  $('#custom-print-preview').show();

  $('.big-preview-wrapper').hide();
  $('.hide-on-custom-mode').hide();

  if (cropper == null) {
    initializeCropper();
  }
};

// if the photo is in a not supported format, we need to show the cropper as a default option
// and prevent the user from clickin on the buy button
const initCropperIfNecessary = () => {
  if ($('#no-products').length > 0 ) {
    showCropper();
    $('#hide-customize-controls').hide();
  }
};


//initCropperIfNecessary();

$('.cp-rotate').click(function () {
  rotateCustomizePrint($(this).data('degree'));
});

$('.cp-set-horizontal-or-vertical').click(function () {
  const value = $(this).data('axis');
  showButtonsOfAxis(value);
});

$('.cp-set-aspect-ratio').click(function () {
  changeAspectRatioCustomizePrint(
    $(this).data('aspect-ratio-value-a'),
    $(this).data('aspect-ratio-value-b'),
  );

  highlightRatioButton(
    $(this).data('aspect-ratio-value-a'),
    $(this).data('aspect-ratio-value-b'),
  );
});

$('#cp-toggle-black-and-white').click(toggleBlackAndWhiteFilter);

$('.cp-confirm').click(function () {
  saveCustomizePrint($(this).data('photo-id'));
});

$('#show-customize-controls').click(showCropper);
$('#hide-customize-controls').click(hideCropper);

$('#cp-restore-original').click(function () {
  restoreOriginalCustomizePrint($(this).data('photo-id'));
});


function replacePhotoOnWallWithCroppedImage(image_url) {
  $('#photo-on-wall').attr('src', image_url);
}


function showRestoreButton() {
  $('#cp-restore-original').show();
}

function hideRestoreButton() {
  $('#cp-restore-original').hide();
}


export {
  initCropperIfNecessary,
};